import React, { useMemo, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './SidebarEstudiante.css';

const STUDENT_OPTION_IDS = new Set([null, 'resultados', 'reportes']);

function SidebarEstudiante({ onSelectOption, selectedOption }) {
  const [colapsado, setColapsado] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { isOwner } = useAuth();

  const allOpciones = [
    {
      id: null,
      iconSrc: '/icons/sidebard/available-exams.png',
      label: 'Available Exams',
      badge: null,
      ruta: '/exams',
    },
    {
      id: 'resultados',
      iconSrc: '/icons/sidebard/exam-results.png',
      label: 'Exam Results',
      badge: null,
      ruta: '/exam-results',
    },
    {
      id: 'reportes',
      iconSrc: '/icons/sidebard/error-reports.png',
      label: 'Error Reports',
      badge: null,
      ruta: '/my-error-reports',
    },
    {
      id: 'administrador',
      iconSrc: '/icons/sidebard/exam-administrator.png',
      label: 'Exam Administrator',
      badge: null,
      ruta: '/exam-administrator',
    },
    {
      id: 'empresas',
      iconSrc: '/icons/sidebard/administration.png',
      label: 'Companies',
      badge: null,
      ruta: '/companies',
    },
    {
      id: 'crear',
      iconSrc: '/icons/sidebard/create-exam.png',
      label: 'Create Exam',
      badge: null,
      ruta: '/create-exam',
    },
    {
      id: 'reportes-admin',
      iconSrc: '/icons/sidebard/error-reports.png',
      label: 'Error Reports (Admin)',
      badge: null,
      ruta: '/error-reports',
    },
    {
      id: 'administration',
      iconSrc: '/icons/sidebard/administration.png',
      label: 'Administration',
      badge: null,
      ruta: '/administration',
    },
  ];

  const opciones = useMemo(() => {
    if (isOwner) return allOpciones;
    return allOpciones.filter((op) => STUDENT_OPTION_IDS.has(op.id));
  }, [isOwner]);

  const toggleColapsar = () => {
    setColapsado(!colapsado);
  };

  const handleOptionClick = (opcion) => {
    if (opcion.ruta) {
      if (onSelectOption) {
        onSelectOption(null);
      }
      navigate(opcion.ruta);
    } else {
      if (location.pathname === '/exams' && onSelectOption) {
        onSelectOption(opcion.id);
      } else {
        if (onSelectOption) {
          onSelectOption(null);
        }
        if (opcion.ruta) {
          navigate(opcion.ruta);
        }
      }
    }
  };

  const isActive = (opcion) => {
    if (opcion.ruta) {
      if (location.pathname !== opcion.ruta) {
        return false;
      }

      if (opcion.ruta === '/exams') {
        return !selectedOption;
      }

      return true;
    }

    return (
      location.pathname === '/exams' &&
      selectedOption !== null &&
      selectedOption !== undefined &&
      selectedOption === opcion.id
    );
  };

  return (
    <div className={`sidebar-estudiante ${colapsado ? 'colapsado' : ''}`}>
      <nav className="sidebar-menu">
        {opciones.map((opcion) => (
          <button
            key={opcion.id !== undefined && opcion.id !== null ? opcion.id : 'home'}
            className={`sidebar-menu-item ${opcion.id === 'crear' ? 'sidebar-menu-item--create-exam' : ''} ${isActive(opcion) ? 'active' : ''}`}
            onClick={() => handleOptionClick(opcion)}
            title={colapsado ? opcion.label : ''}
          >
            <span className="sidebar-menu-icon">
              {opcion.iconSrc ? (
                <img
                  src={opcion.iconSrc}
                  alt=""
                  className={`sidebar-menu-icon-img${opcion.id === 'crear' ? ' sidebar-menu-icon-img--create-exam' : ''}`}
                />
              ) : (
                opcion.icono
              )}
            </span>
            {!colapsado && (
              <>
                <span className="sidebar-menu-label">{opcion.label}</span>
                {opcion.badge && (
                  <span className="sidebar-menu-badge">{opcion.badge}</span>
                )}
              </>
            )}
          </button>
        ))}
      </nav>

      <div className="sidebar-header">
        <button
          type="button"
          className="sidebar-logo-toggle"
          onClick={toggleColapsar}
          title={colapsado ? 'Expand' : 'Hide Menu'}
          aria-expanded={!colapsado}
        >
          <img
            src="/icons/sidebard.png"
            alt=""
            className="sidebar-logo-img"
          />
          {!colapsado && (
            <span className="sidebar-header-label">Hide Menu</span>
          )}
        </button>
      </div>
    </div>
  );
}

export default SidebarEstudiante;
